module.exports = __webpack_public_path__ + "static/img/2s-info-b4.065741d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-info-b4.jpg
// module id = usSO
// module chunks = 0